import React from 'react';
import SubNavbar from '../Components/SubNavbar/SubNavbar';
import Pages from './Components/Pages';
import Footer from '../../Components/Footer/Footer'

export default function Engineering() {
  return (
    <div>
      <SubNavbar />
      <Pages />
      <Footer />
    </div>
  );
}
